import {
    AbacoWebModule,
    MenuItem,
    RouterReadyEvent,
    VueRouter
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from "./menu";
import AssetsVuexModule from './state';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module/index";
import { HTTPClient } from '@abaco/web-common/src/HTTP';

import WarehouseApi from './api/WarehouseApi';
import FertilizerApi from './api/FertilizerApi';
import WaterApi from './api/WaterApi';
import FuelApi from './api/FuelApi';
import ElectricityApi from './api/ElectricityApi';
import PhytochemicalApi from './api/PhytochemicalApi';
import SeedApi from './api/SeedApi';
import ProductApi from './api/ProductApi';
import DocumentApi from './api/DocumentApi';
import EquipmentApi from './api/EquipmentApi';
import PlotApi from './api/PlotApi';
import CombinationApi from './api/CombinationApi';
import IOTServiceApi from './api/IOTServiceApi';
import BuildingApi from './api/BuildingApi';
import TeamApi from './api/TeamApi';
import TraceabilityApi from './api/TraceabilityApi';
import GlobalState from "@abaco/portal-global-state/src/modules/global-state/index";
import MovementApi from "./api/MovementApi";
import WorkShiftApi from './api/WorkShiftApi';
import StaffApi from './api/StaffApi';
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import DashboardChartsModule from '@abaco/dashboard-module/src/modules/charts';

const rootPath = "/sitiagri-rest-api/api_basic";
const state = new AssetsVuexModule();

export const MODULE_ID = "assets";
export default class AssetsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private router!: VueRouter;

    private apiCreated = false;
    private warApi!: WarehouseApi;
    private ferApi!: FertilizerApi;
    private watApi!: WaterApi;
    private fuApi!: FuelApi;
    private elApi!: ElectricityApi;
    private phyApi!: PhytochemicalApi;
    private seeApi!: SeedApi;
    private prodApi!: ProductApi;
    private docApi!: DocumentApi;
    private equipApi!: EquipmentApi;
    private pltApi!: PlotApi;
    private cmbApi!: CombinationApi;
    private iotseApi!: IOTServiceApi;
    private buiApi!: BuildingApi;
    private teApi!: TeamApi;
    private trApi!: TraceabilityApi;
    private mvmntApi!: MovementApi;
    private worApi!: WorkShiftApi;
    private stApi!: StaffApi;


    readonly vuexModule = state;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const WarehouseApi = (await import("./api/WarehouseApi")).default;
        this.warApi = new WarehouseApi(http, rootPath);

        const FertilizerApi = (await import("./api/FertilizerApi")).default;
        this.ferApi = new FertilizerApi(http, rootPath);

        const PhytochemicalApi = (await import("./api/PhytochemicalApi")).default;
        this.phyApi = new PhytochemicalApi(http, rootPath);

        const SeedApi = (await import("./api/SeedApi")).default;
        this.seeApi = new SeedApi(http, rootPath);

        const ProductApi = (await import("./api/ProductApi")).default;
        this.prodApi = new ProductApi(http, rootPath);

        const DocumentApi = (await import("./api/DocumentApi")).default;
        this.docApi = new DocumentApi(http, rootPath);

        const FuelApi = (await import("./api/FuelApi")).default;
        this.fuApi = new FuelApi(http, rootPath);

        const EquipmentApi = (await import("./api/EquipmentApi")).default;
        this.equipApi = new EquipmentApi(http, rootPath);

        const PlotApi = (await import("./api/PlotApi")).default;
        this.pltApi = new PlotApi(http, rootPath);

        const CombinationApi = (await import("./api/CombinationApi")).default;
        this.cmbApi = new CombinationApi(http, rootPath);

        const IOTServiceApi = (await import("./api/IOTServiceApi")).default;
        this.iotseApi = new IOTServiceApi(http, rootPath);

        const BuildingApi = (await import("./api/BuildingApi")).default;
        this.buiApi = new BuildingApi(http, rootPath);

        const TeamApi = (await import("./api/TeamApi")).default;
        this.teApi = new TeamApi(http, rootPath);

        const TraceabilityApi = (await import("./api/TraceabilityApi")).default;
        this.trApi = new TraceabilityApi(http, rootPath);

        const WaterApi = (await import("./api/WaterApi")).default;
        this.watApi = new WaterApi(http, rootPath);

        const MovementApi = (await import("./api/MovementApi")).default;
        this.mvmntApi = new MovementApi(http, rootPath);

        const WorkShiftApi = (await import("./api/WorkShiftApi")).default;
        this.worApi = new WorkShiftApi(http);

        const StaffApi = (await import("./api/StaffApi")).default;
        this.stApi = new StaffApi(http, rootPath);

        const ElectricityApi = (await import("./api/ElectricityApi")).default;
        this.elApi = new ElectricityApi(http, rootPath);

    }

    get warehouseApi() {
        return this.warApi;
    }
    get fertilizerApi() {
        return this.ferApi;
    }
    get phytochemicalApi() {
        return this.phyApi;
    }
    get seedApi() {
        return this.seeApi;
    }
    get productApi() {
        return this.prodApi;
    }
    get documentApi() {
        return this.docApi;
    }
    get fuelApi() {
        return this.fuApi;
    }
    get electricityApi() {
        return this.elApi;
    }
    get equipmentApi() {
        return this.equipApi;
    }
    get plotApi() {
        return this.pltApi;
    }
    get combinationApi() {
        return this.cmbApi;
    }
    get iotServiceApi() {
        return this.iotseApi;
    }
    get buildingApi() {
        return this.buiApi;
    }
    get teamApi() {
        return this.teApi;
    }
    get traceabilityApi() {
        return this.trApi;
    }
    get waterApi() {
        return this.watApi;
    }
    get movementApi() {
        return this.mvmntApi;
    }
    get WorkShiftApi() {
        return this.worApi;
    }
    get StaffApi() {
        return this.stApi;
    }

    dependsOn = {
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GlobalState.MODULE_ID]: () => new GlobalState(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule()
    }

}
